import React from "react";
import { Handle, Position } from "@xyflow/react";
import { Box, Typography, Chip } from "@mui/material";
import { CategoryOutlined } from "@mui/icons-material";

const SemiProductNode = ({ data }) => {
  return (
    <Box
      sx={{
        position: "relative",
        padding: "18px",
        borderRadius: "16px",
        background: "#ffffff",
        border: "2px solid #a855f7",
        minWidth: 240,
        boxShadow: "0 8px 24px rgba(168, 85, 247, 0.15)",
        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: "0 12px 32px rgba(168, 85, 247, 0.25)",
        },
      }}
    >
      <Handle
        type="target"
        position={Position.Left}
        style={{
          background: "#a855f7",
          width: 12,
          height: 12,
          border: "3px solid #ffffff",
          boxShadow: "0 2px 8px rgba(168, 85, 247, 0.4)",
        }}
      />

      {/* 헤더 */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
        <Box
          sx={{
            width: 36,
            height: 36,
            borderRadius: "10px",
            background: "linear-gradient(135deg, #a855f7 0%, #9333ea 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 4px 12px rgba(168, 85, 247, 0.3)",
          }}
        >
          <CategoryOutlined sx={{ color: "#fff", fontSize: 20 }} />
        </Box>
        <Chip
          label="반제품"
          size="small"
          sx={{
            bgcolor: "#faf5ff",
            color: "#7e22ce",
            fontWeight: 600,
            fontSize: "0.7rem",
            height: 22,
          }}
        />
      </Box>

      {/* 반제품명 */}
      <Typography
        variant="subtitle1"
        sx={{
          fontWeight: 700,
          fontSize: "1rem",
          color: "#0f172a",
          mb: 1.5,
          lineHeight: 1.3,
        }}
      >
        {data.label}
      </Typography>

      {/* 수량 정보 */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          p: 1.5,
          bgcolor: "#faf5ff",
          borderRadius: "10px",
          border: "1px solid #e9d5ff",
        }}
      >
        <Typography
          variant="caption"
          sx={{ color: "#7e22ce", fontSize: "0.75rem" }}
        >
          수량
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: "#581c87",
            fontWeight: 700,
            fontSize: "0.9rem",
          }}
        >
          {data.quantity} {data.qty_unit}
        </Typography>
      </Box>

      <Handle
        type="source"
        position={Position.Right}
        style={{
          background: "#a855f7",
          width: 12,
          height: 12,
          border: "3px solid #ffffff",
          boxShadow: "0 2px 8px rgba(168, 85, 247, 0.4)",
        }}
      />
    </Box>
  );
};

export default SemiProductNode;
